module.exports = __webpack_public_path__ + "img/logo-union-pay.3c1c3a32.png";